import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SharedDataService } from './shared-data.service';
import { StaticDataService } from './static-data.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private sharedService: SharedDataService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem(StaticDataService.tokenLiteral)) {
            // logged in so return true           
            let token = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral));
            if(!sessionStorage.getItem(StaticDataService.domainLiteral) && route.queryParams['domain']) {
                sessionStorage.setItem(StaticDataService.domainLiteral, route.queryParams['domain']);
            }
            else if(!sessionStorage.getItem(StaticDataService.domainLiteral) && token.user.domainPermissions != null){
                sessionStorage.setItem(StaticDataService.domainLiteral, Object.keys(token.user.domainPermissions)[0]);
                this.resetTenantName();
            }
            else if(!sessionStorage.getItem(StaticDataService.domainLiteral)){
                sessionStorage.setItem(StaticDataService.domainLiteral, token.user.domains[0]);
            }
            if(!localStorage.getItem(StaticDataService.domains_all)) {
                const domainArr = [{"id":token.user.domains[0]},{"name":"livemint"}]
                localStorage.setItem(StaticDataService.domains_all, JSON.stringify(domainArr));
            }
            return true; 
        }
        this.sharedService.returnUrl = state.url;
        
        this.router.navigate(['/login']);
        return false;
    }

    //copied url paste into new tab when session id will be present but tenant name would be null in that case
    //added this function for sending data to GA
    resetTenantName(){
        let allTenantData=JSON.parse(localStorage.getItem(StaticDataService.allDomains));
        let index;
        let tenantName;
        let selectedDomain =  sessionStorage.getItem(StaticDataService.domainLiteral);
        if(!!allTenantData && !!selectedDomain){
            index=allTenantData.findIndex((value)=>value.id== selectedDomain);
            tenantName=allTenantData[index].name
            sessionStorage.setItem(StaticDataService.tenantName, tenantName);
        }
    }
}
